
import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import aiAgentStore from "Stores/AIAgentStore";
import SplitLayout from "Components/AIAgent/SplitLayout";
import AIAgentPanel from "Components/AIAgent/AIAgentPanel";
import MessageBridge, { MessageTypes } from "Utils/MessageBridge";

const Shell = observer(() => {
  const iframeRef = useRef(null);
  const [initialUrl] = useState(() => {
    // Construct the App URL. 
    // If we are at /dashboard, iframe src should be /dashboard?view=app
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("view", "app");
    return currentUrl.toString();
  });

  useEffect(() => {
    // Listen for messages from Iframe
    const cleanup = MessageBridge.listen({
      [MessageTypes.TOGGLE_AI_PANEL]: () => {
        aiAgentStore.toggle();
      },
      [MessageTypes.DISPLAY_MESSAGE]: (payload) => {
        aiAgentStore.addMessage({ text: payload, sender: 'App', type: 'received' });
        if (!aiAgentStore.isOpen) aiAgentStore.setIsOpen(true);
      },
      [MessageTypes.SYNC_URL]: (payload) => {
        if (payload?.path) {
          // Update the browser URL without reloading
          // We remove '?view=app' from the visible URL for cleanliness
          const newPath = payload.path;
          window.history.replaceState(null, "", newPath);
        }
      }
    });

    return cleanup;
  }, []);

  return (
    <SplitLayout
      isOpen={aiAgentStore.isOpen}
      left={
        <iframe
          ref={iframeRef}
          id="main-app"
          title="Salesgear App"
          src={initialUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      }
      right={
        <AIAgentPanel iframeRef={iframeRef} />
      }
    />
  );
});

export default Shell;
